module.exports = __webpack_public_path__ + "img/better-doubles-lr.1e4d4014.jpg";